import { render, staticRenderFns } from "./AlcoholCard.vue?vue&type=template&id=564bbd37&scoped=true"
import script from "./AlcoholCard.vue?vue&type=script&lang=js"
export * from "./AlcoholCard.vue?vue&type=script&lang=js"
import style0 from "./AlcoholCard.vue?vue&type=style&index=0&id=564bbd37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bbd37",
  null
  
)

export default component.exports